export const MEMBER_ATTENDANCE_LOOKBACK_DAYS = 365;
export const MEMBER_ATTENDANCE_FULL_HISTORY_DAYS = 3650;

export function isFullAttendanceHistory(days: number): boolean {
  return days >= MEMBER_ATTENDANCE_FULL_HISTORY_DAYS;
}

export function memberAttendanceLookbackLabel(days: number): string {
  return isFullAttendanceHistory(days)
    ? "all recorded sessions"
    : "the last 12 months";
}

export function memberAttendanceDateRange(lookbackDays = MEMBER_ATTENDANCE_LOOKBACK_DAYS): {
  fromDate: Date;
  toDate: Date;
} {
  const toDate = new Date();
  toDate.setHours(12, 0, 0, 0);
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - lookbackDays);
  return { fromDate, toDate };
}
